if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        // Slide changed event
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        // Thumbnail click events
        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');

              if (!button) return;

              button.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            });
        }

        // Desktop thumbnail layout
        if (
          this.dataset.desktopLayout?.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const mediaId =
          event.detail?.currentElement?.dataset?.mediaId;

        if (!mediaId) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend = false) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        // Remove active states
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        // Move active media to beginning
        if (prepend) {
          if (
            activeMedia.parentElement.firstChild !== activeMedia
          ) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth',
            });
          }

          const activeMediaRect =
            activeMedia.getBoundingClientRect();

          // Prevent unnecessary scroll jump
          if (activeMediaRect.top > -0.5) return;

          const top =
            activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        // Remove current states
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((button) => {
            button.removeAttribute('aria-current');
          });

        const button = thumbnail.querySelector('button');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        const thumbnailsContainer =
          this.elements.thumbnails;

        const containerRect =
          thumbnailsContainer.getBoundingClientRect();

        const thumbRect =
          thumbnail.getBoundingClientRect();

        const isVisible =
          thumbRect.left >= containerRect.left - 10 &&
          thumbRect.right <= containerRect.right + 10;

        if (isVisible) return;

        thumbnailsContainer.scrollTo({
          left: thumbnail.offsetLeft,
          behavior: 'smooth',
        });
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;

        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}